import React, { useState } from 'react';
import { TfiMoreAlt } from "react-icons/tfi";
import { FaEdit, FaTimes, FaVolumeUp, FaToggleOn, FaToggleOff } from "react-icons/fa";
import { IoMdSearch, IoMdSettings, IoIosArchive, IoIosHelpCircle } from "react-icons/io";
import { LuMessageSquareOff } from "react-icons/lu";
import { MdOutlineReport, MdPayment, MdOutlineBlock } from "react-icons/md";
import setup from '../../assets/setup.jpg';
import setup2 from '../../assets/setup2.jpg';
import profile from '../../assets/profile.jpg';
import styles from './Sidebar.module.css';

const users = [
  { id: 1, profile: setup, name: 'Jimmy Paul', lastSeen: 'Yesterday', lastMessage: 'Hey, are you available for an electrical installation?', role: 'Electrician' },
  { id: 2, profile: setup2, name: 'Smith Paul', lastSeen: '1 hour ago', lastMessage: 'Thanks for the plumbing work!', role: 'Plumber' },
  { id: 3, profile: profile, name: 'John Bright', lastSeen: 'Friday', lastMessage: 'When can you start the renovation?', role: 'Contractor' },
];

const Sidebar = ({ onSelectUser }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notificationsOn, setNotificationsOn] = useState(true);
  const [doNotDisturb, setDoNotDisturb] = useState(false);

  const toggleDrop = () => setIsOpen(!isOpen);
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setIsOpen(false);
  };
  const toggleNotifications = () => setNotificationsOn(!notificationsOn);
  const toggleDoNotDisturb = () => setDoNotDisturb(!doNotDisturb);

  return (
    <div className={styles.sidebar}>
      <header className={styles.sidebarHeader}>
        <div className={styles.top}>
          <h2>Chats</h2>
          <div className={styles.topIcons}>
            <button className={styles.dropButton} onClick={toggleDrop}>
              <TfiMoreAlt size={20} />
            </button>
            <button className={styles.editButton}>
              <FaEdit size={16} />
            </button>
          </div>
        </div>

        {isOpen && (
          <div className={styles.dropdown}>
            <ul className={styles.menu}>
              <li className={styles.menuItem} onClick={toggleModal}>
                <IoMdSettings className={styles.menuIcon} />
                <span className={styles.menuText}>Preference</span>
              </li>
              <li className={styles.menuItem}>
                <IoIosArchive className={styles.menuIcon} />
                <span className={styles.menuText}>Archive chats</span>
              </li>
              <li className={styles.menuItem}>
                <LuMessageSquareOff className={styles.menuIcon} />
                <span className={styles.menuText}>Restricted accounts</span>
              </li>
              <li className={styles.menuItem}>
                <MdOutlineReport className={styles.menuIcon} />
                <span className={styles.menuText}>Reported chats</span>
              </li>
              <li className={styles.menuItem}>
                <IoIosHelpCircle className={styles.menuIcon} />
                <span className={styles.menuText}>Help</span>
              </li>
            </ul>
          </div>
        )}

        {isModalOpen && (
          <div className={styles.modal}>
            <header className={styles.modalHeader}>
              <h3 className={styles.modalTitle}>Preferences</h3>
              <button className={styles.closeButton} onClick={toggleModal}>
                <FaTimes />
              </button>
            </header>

            <div className={styles.modalSection}>
              <h4 className={styles.sectionTitle}>Account</h4>
              <div className={styles.accountDetails}>
                <img src={profile} alt="Profile" className={styles.accountAvatar} />
                <div className={styles.accountInfo}>
                  <p className={styles.accountName}>Jimmy Paul</p>
                  <a href="#" className={styles.accountLink}>See your profile</a>
                </div>
              </div>
            </div>

            <div className={styles.modalSection}>
              <div className={styles.activeStatus}>
                <img src={setup} alt="Active" className={styles.activeAvatar} />
                <p className={styles.activeText}>Active Status: <span>ON</span></p>
              </div>
            </div>

            <div className={styles.modalSection}>
              <h4 className={styles.sectionTitle}>Notifications</h4>
              <div className={styles.notificationItem}>
                <FaVolumeUp className={styles.notificationIcon} />
                <div className={styles.notificationContent}>
                  <p className={styles.notificationTitle}>Notification sounds</p>
                  <p className={styles.notificationDesc}>Use sounds to notify you about incoming messages, calls, and video chats</p>
                </div>
                <div onClick={toggleNotifications} className={styles.toggle}>
                  {notificationsOn ? <FaToggleOn /> : <FaToggleOff />}
                </div>
              </div>
              <div className={styles.notificationItem}>
                <FaVolumeUp className={styles.notificationIcon} />
                <div className={styles.notificationContent}>
                  <p className={styles.notificationTitle}>Do not Disturb</p>
                  <p className={styles.notificationDesc}>Mute notifications for specific period of time</p>
                </div>
                <div onClick={toggleDoNotDisturb} className={styles.toggle}>
                  {doNotDisturb ? <FaToggleOn /> : <FaToggleOff />}
                </div>
              </div>
            </div>

            <div className={styles.modalSection}>
              <div className={styles.otherOptions}>
                <div className={styles.optionItem}>
                  <MdPayment className={styles.optionIcon} />
                  <span className={styles.optionText}>Manage Payment</span>
                </div>
                <div className={styles.optionItem}>
                  <MdOutlineBlock className={styles.optionIcon} />
                  <span className={styles.optionText}>Manage blocking</span>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className={styles.searchContainer}>
          <IoMdSearch className={styles.searchIcon} />
          <input
            type="text"
            placeholder="Search conversations..."
            className={styles.searchInput}
          />
        </div>
      </header>

      <div className={styles.usersList}>
        {users.map(user => (
          <div key={user.id} className={styles.user} onClick={() => onSelectUser(user)}>
            <div className={styles.userInfo}>
              <img src={user.profile} alt={user.name} className={styles.userAvatar} />
              <div className={styles.userDetails}>
                <h4 className={styles.userName}>{user.name}</h4>
                <p className={styles.userStatus}>
                  <span className={styles.statusIndicator}></span>
                  Last seen {user.lastSeen}
                </p>
                <p className={styles.userLastMessage}>{user.lastMessage}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;